import { render, staticRenderFns } from "./BindGoods.vue?vue&type=template&id=dc769f5c&scoped=true&"
import script from "./BindGoods.vue?vue&type=script&lang=ts&"
export * from "./BindGoods.vue?vue&type=script&lang=ts&"
import style0 from "./BindGoods.vue?vue&type=style&index=0&id=dc769f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc769f5c",
  null
  
)

export default component.exports